import { FilterValues, FILTER_PARAMS, slugifyFilter } from '../filters';

export const writeFilterParams = (f: FilterValues) => {
    try {
        const { pathname, hash } = window.location;
        const params = new URLSearchParams(window.location.search);
        const setOrDelete = (key: string, value: string | null) => {
            if (value) {
                params.set(key, slugifyFilter(value));
            } else {
                params.delete(key);
            }
        };
        setOrDelete(FILTER_PARAMS.location, f.location);
        setOrDelete(FILTER_PARAMS.department, f.department);
        const qs = params.toString();
        window.history.replaceState(null, '', `${pathname}${qs ? `?${qs}` : ''}${hash}`);
    } catch {
        // sandboxed iframe (storybook) may forbid replaceState — non-fatal
    }
};
